// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.xq96xh0 {
  background: var(--_18w76bw27);
  padding: 0 10px;
  font-family: Museo Sans,Arial,sans-serif;
  font-size: var(--_18w76bw3w);
  font-weight: var(--_18w76bw3z);
}
.xq96xh1 {
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
}
.xq96xh2 {
  max-width: 400px;
  height: 110px;
  display: flex;
  padding-top: 12px;
  padding-left: 16px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.xq96xh3 {
  color: white;
  line-height: var(--_18w76bw47);
  font-size: var(--_18w76bw3s);
  font-weight: var(--_18w76bw42);
}
.xq96xh4 {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
@media screen and (min-width: 769px) {
  .xq96xh0 {
    font-size: var(--_18w76bw3w);
  }
}
@media screen and (max-width: 768px) {
  .xq96xh0 {
    font-size: 24px;
  }
  .xq96xh2 {
    height: 60px;
    padding: 10px 0px 0px 8px;
  }
  .xq96xh3 {
    font-size: 14px;
    font-weight: var(--_18w76bw42);
  }
  .xq96xh4 {
    position: absolute;
    height: 50px;
    bottom: 0px;
    right: 0px;
    width: auto;
  }
}
@media screen and (max-width: 1024px) {
  .xq96xh1 {
    grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,eAAe;EACf,wCAAwC;EACxC,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,2DAA2D;AAC7D;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,8BAA8B;EAC9B,4BAA4B;EAC5B,8BAA8B;AAChC;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,8BAA8B;EAChC;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,UAAU;IACV,WAAW;EACb;AACF;AACA;EACE;IACE,2DAA2D;EAC7D;AACF","sourcesContent":[".xq96xh0 {\n  background: var(--_18w76bw27);\n  padding: 0 10px;\n  font-family: Museo Sans,Arial,sans-serif;\n  font-size: var(--_18w76bw3w);\n  font-weight: var(--_18w76bw3z);\n}\n.xq96xh1 {\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n}\n.xq96xh2 {\n  max-width: 400px;\n  height: 110px;\n  display: flex;\n  padding-top: 12px;\n  padding-left: 16px;\n  position: relative;\n  border-radius: 4px;\n  overflow: hidden;\n}\n.xq96xh3 {\n  color: white;\n  line-height: var(--_18w76bw47);\n  font-size: var(--_18w76bw3s);\n  font-weight: var(--_18w76bw42);\n}\n.xq96xh4 {\n  display: block;\n  width: 100%;\n  height: auto;\n  object-fit: contain;\n}\n@media screen and (min-width: 769px) {\n  .xq96xh0 {\n    font-size: var(--_18w76bw3w);\n  }\n}\n@media screen and (max-width: 768px) {\n  .xq96xh0 {\n    font-size: 24px;\n  }\n  .xq96xh2 {\n    height: 60px;\n    padding: 10px 0px 0px 8px;\n  }\n  .xq96xh3 {\n    font-size: 14px;\n    font-weight: var(--_18w76bw42);\n  }\n  .xq96xh4 {\n    position: absolute;\n    height: 50px;\n    bottom: 0px;\n    right: 0px;\n    width: auto;\n  }\n}\n@media screen and (max-width: 1024px) {\n  .xq96xh1 {\n    grid-template-columns: repeat(auto-fit, minmax(155px, 1fr));\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
